import { SignatureState } from '@builddocs/filestore-api'
import {
  getDigestRegistry,
  getDigestFinalRegistry,
} from '@builddocs/filestore-api'

type PrepareHashArgs = {
  documentId: string
  employmentId: string
  imprint: string
  keyIssuer: string
  certificateDateStart: string
  certificateDateEnd: string
  signerName: string
  facePhoto: string
  keySerialNumber: string
  type: 'default' | 'final'
  withPoa?: boolean
  poaId?: string | null
  poaDateStart?: string | null
  poaDateEnd?: string | null
}

export const prepareHash = async ({
  documentId,
  employmentId,
  imprint,
  keyIssuer,
  certificateDateStart,
  certificateDateEnd,
  signerName,
  facePhoto,
  keySerialNumber,
  type,
  withPoa,
  poaId,
  poaDateStart,
  poaDateEnd,
}: PrepareHashArgs) => {
  const args = {
    base64signature: null,
    documentId,
    employmentId,
    imprint,
    keyIssuer,
    signatureState: SignatureState.PENDING as SignatureState.PENDING,
    certificateDateStart,
    certificateDateEnd,
    name: signerName,
    faceId: {
      faceImage: facePhoto,
      keySerialNumber,
    },
    withPoa,
    poaId,
    poaDateStart,
    poaDateEnd,
  }

  const aosrDigestResponse =
    type === 'default'
      ? await getDigestRegistry(args)
      : await getDigestFinalRegistry(args)

  return aosrDigestResponse
}
